import { AmplitudeExperiments, AmplitudeVariants } from '../AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '../utils/useAmplitudeExperimentBase';

export const usePopularityScoreReRanking = () =>
    useAmplitudeExperimentBase(
        AmplitudeExperiments.PopularityScoreReRanking,
        AmplitudeVariants.PopularityScoreReRanking.Control
    );
